module.exports = __webpack_public_path__ + "49e3f006018662f60f1db2aec0b2cca9.png";


//////////////////
// WEBPACK FOOTER
// ./bower_components/select2/select2x2.png
// module id = 1251
// module chunks = 1